// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"354":"53714fb2","480":"274405d8","594":"f98012ca","838":"962e261f"}[chunkId] + ".js";
};